import { create } from "zustand";

import type {
  CaseIntakeFlowConfig,
  CaseIntakeFlowStep,
  FlowData,
} from "./constants";

export const submitStages = [
  "OPENING_CASE",
  "UPLOADING_DOCUMENTS",
  "FINISHING_UP",
] as const;
export type SubmitStage = (typeof submitStages)[number];

interface State {
  flowConfig?: CaseIntakeFlowConfig;
  flowData?: FlowData;
  currentStep?: string;
  currentStepConfig?: CaseIntakeFlowStep;
  isInitialized: boolean;
  issueId?: string;
  submitStage?: SubmitStage;
}

interface Actions {
  setFlowConfig: (config: CaseIntakeFlowConfig) => void;
  setFlowData: (data: FlowData) => void;
  updateFlowData: (data: Partial<FlowData>) => FlowData | undefined;
  setCurrentStep: (step: string) => void;
  setIsInitialized: (isInitialized: boolean) => void;
  setIssueId: (issueId: string) => void;
  setSubmitStage: (stage: SubmitStage) => void;
  reset: () => void;
}

const initialState: State = {
  isInitialized: false,
};

export const useCaseIntakeFlowStore = create<State & Actions>()((set, get) => ({
  ...initialState,
  setFlowConfig: (flowConfig: CaseIntakeFlowConfig) => {
    set({ flowConfig });
  },
  setFlowData: (data: FlowData) => {
    set({ flowData: data });
  },
  updateFlowData: (data: Partial<FlowData>) => {
    set(state => ({ flowData: { ...state.flowData, ...data } }));

    return get().flowData;
  },
  setCurrentStep: (step: string) => {
    set({ currentStep: step });
    set({ currentStepConfig: get().flowConfig?.steps[step] });
  },
  setIsInitialized: (isInitialized: boolean) => {
    set({ isInitialized });
  },
  setIssueId: (issueId: string) => {
    set({ issueId });
    return get().flowData;
  },
  setSubmitStage: (stage: SubmitStage) => {
    set({ submitStage: stage });
  },
  reset: () => set({ ...initialState }),
}));
